import RfqRequestPreview from './RfqRequestPreviewContainer';

export default RfqRequestPreview;
